<mat-action-list class="p-0">
      <mat-list-item disableRipple style="margin-bottom: 5px !important;" class="mb-2 rounded-2 overflow-hidden" [routerLink]="['/' + 'dashboard']" [routerLinkActive]="'active-item'" #listItem="routerLinkActive" 
       >
        <mat-icon mat-list-icon class="material-icons">dashboard</mat-icon>
        <button class="new_mew">
          Dashboard 
        </button>
      </mat-list-item>
      <div class="sdf_section selected"  *ngFor="let item of businessListData" (click)="openBusinessDetails(item)"
      [ngClass]="{'selected1': isActive(item.hash_id)}"
      >
        <div class="side_img">
            <img [src]="item.default_image.image_thumb_url" onerror="this.src='../../../../assets/images/entity_placeholder.png'" *ngIf="item.revenue_model == 1">
            <img [src]="item.default_image.image_thumb_url" onerror="this.src='../../../../assets/images/fitness-placeholder.png'" *ngIf="item.revenue_model == 2">
        </div>
        <div class="side_textc" >
          <h4 [ngClass]="{'make-text-white': isActive(item.hash_id)}">{{item.name}}</h4>
          <p  [ngClass]="{'make-text-white': isActive(item.hash_id)}">{{item.address_line ? item.address_line : 'No address Info'}}</p>
        </div>
      </div>
      <mat-accordion class="dffrtr">
        <mat-expansion-panel [expanded]="panelState[0]"  (opened)="panelState[0] = true"
                             (closed)="panelState[0] = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="aa_paddf">
              <mat-icon mat-list-icon class="material-icons">calendar_month</mat-icon>
            </div>
             <span class="booking_ht"> Bookings / Queries</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-list-item disableRipple class="mb-2 rounded-2 overflow-hidden " [routerLink]="['/' + 'new-booking']" [routerLinkActive]="'active-item'" #listItem="routerLinkActive">
            <div class="bookingh_section">
            <mat-icon mat-list-icon class="material-icons">person_add</mat-icon>
            <button class="new_mew">
              New booking / query
            </button>
          </div>
          </mat-list-item>
          <mat-list-item disableRipple class="mb-2 rounded-2 overflow-hidden" [routerLink]="['/' + 'enroll-new-member']" [routerLinkActive]="'active-item'" #listItem="routerLinkActive">
            <div class="bookingh_section">
            <mat-icon mat-list-icon class="material-icons">diversity_3</mat-icon>
            <button class="new_mew">
              Enroll new member
            </button>
          </div>
          </mat-list-item>
          <mat-list-item disableRipple class="mb-2 rounded-2 overflow-hidden " [routerLink]="['/' + 'produce-bill']" [routerLinkActive]="'active-item'" #listItem="routerLinkActive">
            <div class="bookingh_section">
            <mat-icon mat-list-icon class="material-icons-outlined">post_add</mat-icon>
            <button class="new_mew">
              Produce bill / invoice
            </button>
          </div>
          </mat-list-item>
          <mat-list-item disableRipple class="mb-2 rounded-2 overflow-hidden " [routerLink]="['/' + 'all-bookings']" [routerLinkActive]="'active-item'" #listItem="routerLinkActive">
            <div class="bookingh_section">
            <mat-icon mat-list-icon class="material-icons">list</mat-icon>
            <button class="new_mew">
              All activity / queries
            </button>
          </div>
          </mat-list-item>
        </mat-expansion-panel>
      </mat-accordion>

      <mat-list-item disableRipple class="mb-2 rounded-2 overflow-hidden " [routerLink]="['/' + 'service-list']" [routerLinkActive]="'active-item'" #listItem="routerLinkActive">
        <mat-icon mat-list-icon class="material-icons">settings_applications</mat-icon>
        <button class="new_mew">
          Services / Packages
        </button>
      </mat-list-item>
      <mat-list-item disableRipple class="mb-2 rounded-2 overflow-hidden " [routerLink]="['/' + 'business-hours']" [routerLinkActive]="'active-item'" #listItem="routerLinkActive">
        <mat-icon mat-list-icon class="material-icons">hourglass_top</mat-icon>
        <button class="new_mew">
          Business hours 
        </button>
      </mat-list-item>
      <mat-list-item disableRipple class="mb-2 rounded-2 overflow-hidden " [routerLink]="['/' + 'all-employees']" [routerLinkActive]="'active-item'" #listItem="routerLinkActive">
        <mat-icon mat-list-icon class="material-icons">badge</mat-icon>
        <button class="new_mew">
         Employees 
        </button>
      </mat-list-item>
         <mat-list-item disableRipple class="mb-2 rounded-2 overflow-hidden " [routerLink]="['/' + 'all-customers']" [routerLinkActive]="'active-item'" #listItem="routerLinkActive">
        <mat-icon mat-list-icon class="material-icons">family_restroom</mat-icon>
        <button class="new_mew">
         Customers 
        </button>
      </mat-list-item>
      <mat-list-item disableRipple class="mb-2 rounded-2 overflow-hidden " [routerLink]="['/' + 'all-members']" [routerLinkActive]="'active-item'" #listItem="routerLinkActive">
        <mat-icon mat-list-icon class="material-icons">diversity_3</mat-icon>
        <button class="new_mew">
         Members 
        </button>
      </mat-list-item>

      <mat-list-item disableRipple class="mb-2 rounded-2 overflow-hidden" [routerLink]="['/' + 'contact-us']" [routerLinkActive]="'active-item'" #listItem="routerLinkActive">
        <mat-icon mat-list-icon class="material-icons">contact_page</mat-icon>
        <button class="new_mew">
          Contact us 
        </button>
      </mat-list-item>
      <!-- <mat-list-item disableRipple class="mb-2 rounded-2 overflow-hidden" [routerLink]="['/' + 'share-friends']" [routerLinkActive]="'active-item'" #listItem="routerLinkActive">
        <mat-icon mat-list-icon class="material-icons">share</mat-icon>
        <button class="new_mew">
          Refer a friend
        </button>
      </mat-list-item> -->
      <mat-list-item disableRipple class="mb-2 rounded-2 overflow-hidden" (click)="openLink('https://lookzup.com/help')">
        <mat-icon mat-list-icon class="material-icons">help</mat-icon>
        <button class="new_mew">
          Help document
        </button>
      </mat-list-item>

      <!-- <mat-list-item disableRipple class="mb-2 rounded-2 overflow-hidden" (click)="openLink('https://lookzup.medium.com')">
        <mat-icon mat-list-icon class="material-icons">article</mat-icon>
        <button class="new_mew">
          Blogs
        </button>
      </mat-list-item> -->
       <mat-list-item disableRipple class="mb-2 rounded-2 overflow-hidden " >
        <mat-icon mat-list-icon class="material-icons-outlined">ballot</mat-icon>
        <button class="new_mew">
            {{ 'nav_links.version' | translate}} {{version}}
        </button>
      </mat-list-item>
</mat-action-list>
